module.exports = {
	"1941-05-01-okupacija": {
		"x": 494,
		"y": 100
	},
	"1941-05-10-odvodjenje": {
		"x": 978,
		"y": 300
	},
	"1941-05-15-ravna-gora": {
		"x": 766,
		"y": 500
	},
	"1941-05-15-pripreme": {
		"x": 203,
		"y": 500
	},
	"1941-07-07-zakletva": {
		"x": 167,
		"y": 700
	},
	"1941-08-11-izvestaj": {
		"x": 642,
		"y": 900
	},
	"1941-09-09-diverzija": {
		"x": 212,
		"y": 1100
	},
	"1941-09-24-sabac": {
		"x": 678,
		"y": 1300
	},
	"1941-10-10-kraljevo": {
		"x": 437,
		"y": 1500
	},
	"1943-03-15-opkoljen": {
		"x": 534,
		"y": 1800
	},
	"1944-01-15-opkoljen": {
		"x": 173,
		"y": 2100
	},
	"1945-01-01-straza": {
		"x": 384,
		"y": 2400
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/komponente/editor/pozicije.json
// module id = 50
// module chunks = 0